import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const usePartialPaymentPermission = () => {
  const { isAdmin, isGroomer } = useAuth();
  const [canProcessPartialPayments, setCanProcessPartialPayments] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        // Admins can always process partial payments
        if (isAdmin) {
          setCanProcessPartialPayments(true);
          setLoading(false);
          return;
        }

        // Check if employees are allowed to process partial payments
        if (isGroomer) {
          const token = sessionStorage.getItem('token');
          const response = await axios.get(`${API_URL}/payment-settings`, {
            headers: { Authorization: `Bearer ${token}` }
          });

          const settings = response.data.providers || [];
          // Check if any provider allows employee partial payments
          const allowsEmployeePartial = settings.some(
            provider => provider.allow_employee_partial_payments !== false
          );

          setCanProcessPartialPayments(allowsEmployeePartial);
        } else {
          // Clients cannot process partial payments
          setCanProcessPartialPayments(false);
        }
      } catch (error) {
        console.error('Error checking partial payment permission:', error);
        setCanProcessPartialPayments(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, [isAdmin, isGroomer]);

  return { canProcessPartialPayments, loading };
};

export default usePartialPaymentPermission;
